import { IFilterCategory } from "../../types/filterTypes";

export const getCategoriesIds = (categories: IFilterCategory[]): string[] =>
  categories.filter(category => category.checked).map(category => category.id);
